const babyLayers = [
    {
      id: 'ELL',
      src: '/animation_assets/10_baby_ELL.png',
      width: '18.5px',
      height: '47.4px',
      left: '26.0%',
      top: '53.9%',
      zIndex: 32,
      alt: 'o',
      role: 'text',
      group: 0 // Default group
    },
    {
      id: 'WUT',
      src: '/animation_assets/10_baby_WUT.png',
      width: '23.5px',
      height: '47.4px',
      left: '28.9%',
      top: '53.9%',
      zIndex: 31,
      alt: 'h', 
      role: 'text',
      group: 0 // Default group
    },
    {
      id: 'KUN',
      src: '/animation_assets/10_baby_KUN.png',
      width: '37.7px',
      height: '72.9px',
      left: '35.2%',
      top: '50.3%',
      zIndex: 30,
      alt: 'B',
      role: 'text',
      group: 0 // Default group
    },
    {
      id: 'YID',
      src: '/animation_assets/10_baby_YID.png',
      width: '46.3px',
      height: '72.9px',
      left: '43.7%',
      top: '50.3%',
      zIndex: 29,
      alt: 'A',
      role: 'text',
      group: 0
    },
    {
      id: 'NNB',
      src: '/animation_assets/10_baby_NNB.png',
      width: '37.7px',
      height: '72.9px',
      left: '53.8%',
      top: '50.3%',
      zIndex: 28,
      alt: 'B',
      role: 'text',
      group: 0
    },
    {
      id: 'GWK',
      src: '/animation_assets/10_baby_GWK.png',
      width: '43.1px',
      height: '72.9px',
      left: '62.2%',
      top: '50.3%',
      zIndex: 27,
      alt: 'Y',
      role: 'text',
      group: 0
    },
    {
      id: 'DOY',
      src: '/animation_assets/10_baby_DOY.png',
      width: '22.1px',
      height: '47.6px',
      left: '27.1%',
      top: '64.8%',
      zIndex: 26,
      alt: 't', 
      role: 'text',
      group: 0
    },
    {
      id: 'VEP',
      src: '/animation_assets/10_baby_VEP.png',
      width: '18.6px',
      height: '47.6px',
      left: '31.0%',
      top: '64.8%',
      zIndex: 25,
      alt: 'o',
      role: 'text',
      group: 0
    },
    {
      id: 'OTL',
      src: '/animation_assets/10_baby_OTL.png',
      width: '20.3px',
      height: '47.6px',
      left: '34.2%',
      top: '64.8%',
      zIndex: 24,
      alt: 'y', 
      role: 'text',
      group: 0  
    },
    {
      id: 'LMH',
      src: '/animation_assets/10_baby_LMH.png',
      width: '19.7px',
      height: '47.6px',
      left: '40.0%',
      top: '64.8%',
      zIndex: 23,
      alt: 's',
      role: 'text',
      group: 0
    },
    {
      id: 'EMW',
      src: '/animation_assets/10_baby_EMW.png',
      width: '23.6px',
      height: '47.6px',
      left: '43.0%',
      top: '64.8%',
      zIndex: 22,
      alt: 'h',
      role: 'text',
      group: 0
    },
    {
      id: 'TZJ',
      src: '/animation_assets/10_baby_TZJ.png',
      width: '18.6px',
      height: '47.6px',
      left: '47.3%',
      top: '64.8%',
      zIndex: 21,
      alt: 'o',
      role: 'text',
      group: 0
    },
    {
      id: 'DPB',
      src: '/animation_assets/10_baby_DPB.png',
      width: '23.5px',
      height: '47.6px',
      left: '49.9%',
      top: '64.8%',
      zIndex: 20,
      alt: 'p', 
      role: 'text',
      group: 0
    },
    {
      id: 'WEM',
      src: '/animation_assets/10_baby_WEM.png',
      width: '309.7px',
      height: '189.5px',
      left: '24.4%',
      top: '27.8%',
      zIndex: 19, 
      alt: 'Illustration of a bird with a bag in its mouth.',
      role: 'primary',  
      group: 0 // Default group
    },
    {
      id: 'BOM',
      src: '/animation_assets/10_baby_BOM.png',
      width: '504.0px',
      height: '504.0px',
      left: '0.8%',
      top: '0.7%',
      zIndex: 18,
      role: 'background',
      group: 0, // Default group
      alt: 'Light white background with a white border.'
    }
  ]
  

  export default babyLayers;